<template>
	<div class="min-h-screen">
		<div class="-mx-3 -mt-3 flex flex-wrap">
			<template v-if="!isFiltering">
				<template v-for="(product, index) in products" :key="index">
					<div class="w-full px-3 py-3 sm:w-1/2 xl:w-1/3">
						<FilterCarCardSubscription
							v-if="isSubscription"
							:product="product"
						/>
						<FilterCarCardBuyUsed
							v-if="isBuyUsed"
							:product="product"
						/>
					</div>

					<div
						v-if="index === 4"
						class="flex w-full px-3 py-3 sm:w-1/2 xl:w-1/3"
					>
						<FilterMarketingCardSubscription
							v-if="isSubscription"
						/>
						<FilterMarketingCardBuyUsed v-if="isBuyUsed" />
					</div>
				</template>
			</template>

			<template v-if="!isDirty || isFiltering">
				<div
					v-for="(item, key) in Array(
						products.length ? products.length + 1 : 21
					)"
					:key="key"
					class="flex w-full px-3 py-3 sm:w-1/2 xl:w-1/3"
				>
					<ContentLoader width="w-full" height="h-[400px]" />
				</div>
			</template>
		</div>

		<NoResults v-if="products.length === 0" />

		<div
			v-if="pagination.lastPage && pagination.lastPage > 1"
			class="mt-6 flex justify-center"
		>
			<VueTailwindPagination
				:current="
					pagination.filterNextPage
						? pagination.filterNextPage
						: pagination.currentPage
				"
				:total="pagination.total"
				:per-page="pagination.perPage"
				@page-changed="onPageChanged($event)"
			/>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import FilterCarCardSubscription from '@/components/product-catalog/cards/FilterCarCardSubscription.vue'
import FilterCarCardBuyUsed from '@/components/product-catalog/cards/FilterCarCardBuyUsed.vue'
import FilterMarketingCardSubscription from '@/components/product-catalog/cards/FilterMarketingCardSubscription.vue'
import FilterMarketingCardBuyUsed from '@/components/product-catalog/cards/FilterMarketingCardBuyUsed.vue'
import VueTailwindPagination from '@/components/paginations/VueTailwindPagination.vue'
import NoResults from '@/components/product-catalog/NoResults.vue'
import { useProductCatalog } from '@/stores/product-catalog'
import ContentLoader from '@/components/ContentLoader.vue'

const productCatalog = useProductCatalog()

const props = defineProps({
	pageType: {
		type: String,
	},
})

const emit = defineEmits(['updatePage'])

const products = computed(() => productCatalog.products)

const pagination = computed(() => productCatalog.productsPagination)

const isDirty = computed(() => productCatalog.isDirty)

const isFiltering = computed(() => productCatalog.isFiltering)

const onPageChanged = async (page) => {
	emit('updatePage', page)
}

const isSubscription = computed(() => props.pageType === 'subscribe')
const isBuyUsed = computed(() => props.pageType === 'used')
</script>
